import * as types from "../actions/actionTypes/reports";
import initialState from "./initialState";
import { combineReducers } from "redux";
import merge from "lodash.merge";

const entitiesReducer = (state = initialState.reports.entities, action) => {
  if (action.entitiesCategory && action.entitiesCategory === "reports" && action.entities) {
    return merge({}, state, action.entities);
  }

  return state;
};

const browserDataReducer = (state = initialState.reports.browserData, action) => {
  switch (action.type) {
    case types.CLEAN_BROWSER: {
      let newState = { ...state };
      delete newState[action.browserId];
      return newState;
    }

    default:
  }

  if (
    action.entitiesCategory &&
    action.entitiesCategory === "browserData" &&
    action.entities &&
    action.entities.browserDataItems
  ) {
    let result = { ...state };
    result[action.browserId] = { ...state[action.browserId] };
    result[action.browserId] = merge({}, result[action.browserId], action.entities.browserDataItems);
    return result;
  }

  return state;
};

const reportItemsReducer = (state = initialState.reports.items, action) => {
  switch (action.type) {
    case types.LOAD_REPORT_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true };
      return result;
    }

    case types.LOAD_REPORT_SUCCEEDED: {
      const { key } = action;

      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true };

      return result;
    }

    case types.LOAD_REPORT_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false };
      return result;
    }

    case types.GENERATE_REPORT_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], generating: true };
      return result;
    }

    case types.GENERATE_REPORT_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], generating: false };
      return result;
    }

    case types.GENERATE_REPORT_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], generating: false };
      return result;
    }

    default:
      return state;
  }
};

const browserItemsReducer = (state = initialState.reports.browserItems, action) => {
  switch (action.type) {
    case types.LOAD_BROWSER_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true };
      return result;
    }

    case types.LOAD_BROWSER_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true };
      return result;
    }

    case types.LOAD_BROWSER_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false };
      return result;
    }

    default:
      return state;
  }
};

const reportListReducer = (state = initialState.reports.list, action) => {
  switch (action.type) {
    case types.LOAD_REPORTS_STARTED: {
      const { key, page, pageSize } = action;
      let result = { ...state };
      result[key] = { ...state[key], pageSize };
      result[key][page] = { ...result[key][page], loading: true };
      return result;
    }

    case types.LOAD_REPORTS_SUCCEEDED: {
      const { key, page, totalCount, totalPages } = action;

      let result = { ...state };
      result[key] = { ...state[key], totalCount, totalPages };
      result[key][page] = { ...result[key][page], ids: [...action.result], loading: false };

      return result;
    }

    case types.LOAD_REPORTS_FAILED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: false };
      return result;
    }

    default:
      return state;
  }
};

const browserDataListReducer = (state = initialState.reports.browserDataList, action) => {
  switch (action.type) {
    case types.LOAD_BROWSERDATA_STARTED: {
      const { key, browserId, page, pageSize } = action;
      let result = { ...state };
      result[browserId] = { ...state[browserId] };
      result[browserId][key] = { ...result[browserId][key], pageSize };
      result[browserId][key][page] = { ...result[browserId][key][page], loading: true };
      return result;
    }

    case types.LOAD_BROWSERDATA_SUCCEEDED: {
      const { key, browserId, page, totalCount } = action;
      let result = { ...state };
      result[browserId] = { ...state[browserId] };
      result[browserId][key] = { ...result[browserId][key], totalCount };
      result[browserId][key][page] = {
        ...result[browserId][key][page],
        loading: false,
        loaded: true,
        ids: [...action.result]
      };
      return result;
    }

    case types.LOAD_BROWSERDATA_FAILED: {
      const { key, browserId, page, pageSize } = action;
      let result = { ...state };
      result[browserId] = { ...state[browserId] };
      result[browserId][key] = { ...result[browserId][key], pageSize };
      result[browserId][key][page] = { ...result[browserId][key][page], loading: false };
      return result;
    }

    case types.CLEAN_BROWSER: {
      let newState = { ...state };
      delete newState[action.browserId];
      return newState;
    }

    default:
      return state;
  }
};

const combinedReducer = combineReducers({
  entities: entitiesReducer,
  list: reportListReducer,
  items: reportItemsReducer,
  browserItems: browserItemsReducer,
  browserData: browserDataReducer,
  browserDataList: browserDataListReducer
});

const exp = (state, action) => combinedReducer(state, action);
export default exp;
